<template>
  <section>
    <div class="slideshow" v-if="page && page.banners && page.banners.length">
      <slide-show @slide-change="slidenumber = $event" ref="slideshow">
        <div :key="banner._id" class="slide" v-for="(banner, i) in page.banners">
          <div class="container">
            <img :alt="banner.alt" :src="banner.image" @load="$store.commit('bannerLoaded', i)" />
            <div class="caption" v-if="banner.caption_1 || banner.caption_2">
              <h3 v-if="banner.caption_1">
                <span
                  :style="banner.caption_colour ? 'color:' + banner.caption_colour : ''"
                >{{banner.caption_1}}</span>
              </h3>
              <h4 v-if="banner.caption_2">
                <span
                  :style="banner.caption_colour ? 'color:' + banner.caption_colour : ''"
                >{{banner.caption_2}}</span>
              </h4>
            </div>
          </div>
        </div>
      </slide-show>

      <a aria-label="Down" v-if="isHomePage" @click.prevent="scrolldown()" class="down" href>
        <font-awesome-icon icon="chevron-circle-down" />
      </a>
      <div class="controls" v-if="page.banners.length > 1">
        <a
          aria-label="Previous"
          @click.prevent="$refs.slideshow.show(slidenumber > 1 ? slidenumber - 1 : page.banners.length)"
          class="prev"
          href
        >
          <font-awesome-icon icon="chevron-left" />
        </a>
        <a
          aria-label="Next"
          @click.prevent="$refs.slideshow.show(slidenumber < page.banners.length ? slidenumber + 1 : 1)"
          class="next"
          href
        >
          <font-awesome-icon icon="chevron-right" />
        </a>
      </div>
      <!--<div class="links">
        <router-link to="/">Our services</router-link>
        <router-link to="/">Pre-paid funerals</router-link>
        <router-link to="/">Obituaries</router-link>
      </div>-->
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex"
import { mapGetters } from "vuex"

var VueScrollTo = require("vue-scrollto")

var options = {
  container: "body",
  easing: "ease-out",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: function() {
    // scrolling started
  },
  onDone: function() {
    // scrolling is done
  },
  onCancel: function() {
    // scrolling has been interrupted
  },
  x: false,
  y: true
}

export default {
  data: function() {
    return {
      slidenumber: 1
    }
  },
  name: "Banners",
  computed: {
    ...mapState(["page"]),
    ...mapGetters(["isHomePage"])
  },
  methods: {
    scrolldown() {
      VueScrollTo.scrollTo("#content", 750, options)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.slideshow {
  position: relative;
  line-height: 0;
}

.slide {
  width: 100%;
  overflow: hidden;
}

.slide img {
  width: 100%;
  position: relative;
  z-index: 1;
}

.caption {
  line-height: 1.2;
  position: absolute;
  z-index: 2;
  left: 20%;
  width: 60%;
  top: 47%;
  text-align: center;
  transform: translateY(-50%);
  font-size: 5.5rem;
  padding: 1rem 0;
}

.links {
  color: White;
  width: 100%;
  text-align: center;
  position: absolute;
  z-index: 20;
  bottom: 15%;
}

.links a {
  width: 15%;
  display: inline-block;
  background: rgba(255, 255, 255, 0.9);
  line-height: 1.3;
  padding: 1rem;
  margin: 2rem;
  font-size: 2rem;
  transition: all 0.2s;
  color: #000;
}

.links a:hover {
  background: rgba(255, 255, 255, 1);
  transform: scale(1.1);
}

h3,
h4 {
  font-weight: 400;
  clear: both;
  display: block;
  margin: 0;
  line-height: 1.5;
}

.caption h3 span {
  color: #53453c;
}

.caption h4 {
  font-size: 4.5rem;
  opacity: 0.8;
}

.down {
  position: absolute;
  bottom: 7rem;
  z-index: 40;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  font-size: 4rem;
}

.caption h4 span {
  color: #53453c;
}

.controls {
  position: absolute;
  top: 47%;
  left: 5%;
  width: 90%;
  transform: translateY(-50%);
  z-index: 3;
  color: #fff;
  font-size: 5rem;
}

.next {
  float: right;
}

.controls a {
  transition: all 0.2s;
  display: inline-block;
}

.controls a:hover {
  transform: scale(1.2);
  color: #ccb298;
}

@media screen and (max-width: 1300px) {
  .caption {
    font-size: 4rem;
  }
  .caption h4 {
    font-size: 3rem;
  }
}

@media screen and (max-width: 980px) {
  .slide img {
    width: 150%;
    max-width: 150%;
    left: -25%;
  }
  .controls {
    display: none;
  }
  .caption {
    width: 80%;
    left: 10%;
  }
  .links a {
    width: 25%;
    font-size: 1.6rem;
  }
}

@media screen and (max-width: 700px) {
  .caption {
    font-size: 2.5rem;
  }
  .caption h4 {
    font-size: 2.2rem;
    margin-top: 0.5rem;
  }
}

@media screen and (max-width: 500px) {
  .slide img {
    width: 200%;
    max-width: 200%;
    left: -50%;
  }
  .links a {
    margin: 0 1rem;
  }
  .down {
    bottom: 3rem;
  }
}
</style>
